import { useEffect } from 'react';
import { SiteActions } from '@/redux/site/actions';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/store';
import {
  Introduction,
  Slider,
  EliteBenefits,
  Shape,
  Elite,
  PrometheusChestplate,
} from '@/modules/prometheus-nft';
import { Footer } from '@/components/Footer';
import { ScrollDown } from '@/components/ScrollDown';
import { LearnMore } from '@/modules/about';

export default function Infrastrucuture() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(SiteActions.loadSite());
  }, []);

  return (
    <div className="infrastructure">
      <Introduction />
      <Slider />
      <EliteBenefits />
      <Shape />
      <Elite />
      <PrometheusChestplate />
      <LearnMore />

      <Footer />

      <ScrollDown anchor="token-sale-stats" />
    </div>
  );
}
